export default __webpack_public_path__ + "static/personality-collaborative-light-d8fd9bfedc94cc97f329f38c8774c50e.png";